import { Box } from '@chakra-ui/react'
import React from 'react'
import { Heading } from '@chakra-ui/react'
import festinoLogo from "../components/images/festinoLogo1.png"
// import './test.css';
import AzaadiLogo from './images/75Logo.png'


const HomePage = () => {
    return (
        <Box style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'space-around',
            flexDirection: 'row',
            height: '658px',
            flexWrap: 'wrap',
            background: `url('${'https://i.ytimg.com/vi/03p33R5h11E/maxresdefault.jpg'}')`,
            backgroundColor: 'linear-gradient(rgba(0,0,0,1),rgba(0,0,0,1))',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
        }}>
            <Box style={{ width: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '0px', marginTop: '100px' }}>
                <Heading color={"orange.500"} style={{ width: '100%', textAlign: 'center', lineHeight: '40px', fontSize: '90px', textShadow: '0px 0px 0px orange' }}>ABESIT</Heading> <br />
                <Heading color={"orange.500"} style={{ width: '100%', textAlign: 'center', lineHeight: '40px', fontSize: '25px', textShadow: '0px 0px 10px black' }}>GROUP OF INSTITUTIONS</Heading>
                <br />
                <Heading color={"green.500"} style={{ width: '100%', textAlign: 'center', lineHeight: '40px', fontSize: '20px', textShadow: '0px 0px 10px black' }}>Presents</Heading>
                <Heading color={"orange.500"} style={{ width: '100%', textAlign: 'center', lineHeight: '40px', fontSize: '35px', textShadow: '0px 0px 10px black' }}>MEGA ANNUAL FEST</Heading>
                <br />
                <img src={AzaadiLogo} alt="75Logo" style={{ width: '150px', position: 'absolute', top: '20px', left: '100px' }} />
            </Box>
            {/* <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
            </Box> */}
            <Box style={{ width: '55vw', minWidth: '320px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '0px' }}>
                <img src={festinoLogo} alt="FestinoLogo" style={{ mixBlendMode: 'normal', minWidth: '320px' }} />
            </Box>
        </Box>
    )
}

export default HomePage